/**
 * @src https://swagger.io/docs/specification/api-host-and-base-path/
 */
const PARCEL_SERVICE_URL = `${process.env.REACT_APP_PROXY_URL}/parcel-service/`;
export default {
  services: {
    trackingNumberCheck: {
      serverUrl: PARCEL_SERVICE_URL + "v1/trackingnumbercheck",
    },
    parcelAddress: {
      serverUrl: PARCEL_SERVICE_URL + "v1/parceladdress",
    },
    redeliveryDetails: {
      serverUrl: PARCEL_SERVICE_URL + "v1/redeliverydetails",
    },
    postshopLocator: {
      serverUrl: `${process.env.REACT_APP_PROXY_URL}/postshop-locations/v2`,
    },
    suggestAddress: {
      serverUrl: `${process.env.REACT_APP_PROXY_URL}/notifications/address-suggestions`,
    },
    sendNotification: {
      serverUrl: `${process.env.REACT_APP_PROXY_URL}/notifications/send-notifications`
    }
  },
};


// WEBPACK FOOTER //
// ./src/config/config.ts